import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type {
  CfOrderDetailResponse,
  CfOrderListResponse,
  CfOrderStatusCountsResponse,
} from "./types";

const base = `${config.apiUrl}/cf-orders`;

export const cfOrdersApi = {
  list(params?: {
    q?: string;
    status?: string;
    source?: string;
    feedType?: "post" | "live";
    limit?: number;
    offset?: number;
  }): Promise<CfOrderListResponse> {
    const q = new URLSearchParams();
    if (params?.q) q.set("q", params.q);
    if (params?.status) q.set("status", params.status);
    if (params?.source) q.set("source", params.source);
    if (params?.feedType) q.set("feedType", params.feedType);
    if (params?.limit != null) q.set("limit", String(params.limit));
    if (params?.offset != null) q.set("offset", String(params.offset));
    const qs = q.toString();
    return fetcher.get(`${base}${qs ? `?${qs}` : ""}`);
  },

  statusCounts(): Promise<CfOrderStatusCountsResponse> {
    return fetcher.get(`${base}/status-counts`);
  },

  getById(id: string): Promise<CfOrderDetailResponse> {
    return fetcher.get(`${base}/${id}`);
  },
};
